export default function createArrayFromXToY(start: number, end: number): number[] {
    // @ts-ignore
    const indexes = [...Array(end + 1 - start).keys()]
    return start !== 0 ? indexes.map((index: number) => (index + start)) : indexes
}